module.exports = __webpack_public_path__ + "img/blackDownArrow.73582fc3.svg";